import { render, staticRenderFns } from "./FullBodyIntelligence.vue?vue&type=template&id=4549aca4&"
import script from "./FullBodyIntelligence.vue?vue&type=script&lang=js&"
export * from "./FullBodyIntelligence.vue?vue&type=script&lang=js&"
import style0 from "./FullBodyIntelligence.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports